import { render } from "./dan-alix-celebrity-style-sec.vue?vue&type=template&id=5e0e699b&scoped=true"
import script from "./dan-alix-celebrity-style-sec.vue?vue&type=script&lang=js"
export * from "./dan-alix-celebrity-style-sec.vue?vue&type=script&lang=js"

import "./dan-alix-celebrity-style-sec.vue?vue&type=style&index=0&id=5e0e699b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e699b"]])

export default __exports__